import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireModule } from '../../../app/guards'

/** Loyalty points (ADR-044): an opt-in module; every page below needs the company to have it. */
export const Route = createFileRoute('/_app/loyalty')({
  beforeLoad: ({ context }) => requireModule(context.session, 'loyalty'),
  component: Outlet,
})
